module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"indoor":"内部発生","indoor_short":"内部","outdoor":"外部発生","outdoor_short":"外部"},"en":{"indoor":"indoor","indoor_short":"indoor","outdoor":"outdoor","outdoor_short":"outdoor"}}')
  delete Component.options._Ctor
}
